import { render, staticRenderFns } from "./inquire-detail.vue?vue&type=template&id=40b37d5e&scoped=true&"
import script from "./inquire-detail.vue?vue&type=script&lang=js&"
export * from "./inquire-detail.vue?vue&type=script&lang=js&"
import style0 from "./inquire-detail.vue?vue&type=style&index=0&id=40b37d5e&prod&lang=less&scoped=true&"
import style1 from "./inquire-detail.vue?vue&type=style&index=1&id=40b37d5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b37d5e",
  null
  
)

export default component.exports